import {
  animate,
  AnimationTriggerMetadata,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const ANIMATION_TIMING = '225ms cubic-bezier(0.4,0.0,0.2,1)';

export const arrowRotateAnimation: AnimationTriggerMetadata = trigger('arrowRotate', [
  state('collapsed, void', style({ transform: 'rotate(0deg)' })),
  state('expanded', style({ transform: 'rotate(180deg)' })),
  transition('expanded <=> collapsed, void => collapsed', animate(ANIMATION_TIMING)),
]);

export const arrowRotate90Animation: AnimationTriggerMetadata = trigger('arrowRotate90', [
  state('collapsed, void', style({ transform: 'rotate(0deg)' })),
  state('expanded', style({ transform: 'rotate(90deg)' })),
  transition('expanded <=> collapsed, void => collapsed', animate(ANIMATION_TIMING)),
]);

export const accordionAnimation: AnimationTriggerMetadata = trigger('toggle', [
  state('*', style({ 'overflow-y': 'hidden' })),
  state('void', style({ 'overflow-y': 'hidden' })),
  transition('* => void', [
    style({ height: '*' }),
    animate(ANIMATION_TIMING, style({ height: '0' })),
  ]),
  transition('void => *', [
    style({ height: '0' }),
    animate(ANIMATION_TIMING, style({ height: '*' })),
  ]),
]);

export const showMoreLessAnimation: AnimationTriggerMetadata = trigger('expandCollapse', [
  state(
    'collapsed',
    style({
      height: '{{height}}',
      overflow: 'hidden',
    }),
    { params: { height: 0 } }
  ),
  state(
    'expanded',
    style({
      height: '*',
      overflow: 'hidden',
    })
  ),
  transition('collapsed <=> expanded', [animate(ANIMATION_TIMING)]),
]);
